<script>
export default {
  name: 'professional-specialities-tab'
}
</script>

<template lang="pug">
  ul.nav.nav-tabs.nav-340
    router-link(:to="{ name: 'professional.record.specialities.index'}", tag="li")
      a(href="#") Listagem
    router-link(:to="{ name: 'professional.record.specialities.create'}", tag="li")
      a(href="#") Cadastro
</template>



// WEBPACK FOOTER //
// src/app/employee/record/specialities/components/tab.vue